export default {
  path: '/box-types',
  name: 'boxTypes',
  component: () => import('./_views/KernelBoxTypes.vue'),
  meta: {
    title: 'Box Types',
    navigation: {
      position: 4,
      name: 'Box Types',
      icon: 'inbox',
      specialQueries: ['suffix'],
      to: {
        name: 'boxTypes',
        query: {
          suffix: '',
          pageNum: '1',
        },
      },
    },
  },
};
